import { TranslationKeys } from '~frontend-common/i18n/english/home-amenities.i18n';

const keys: TranslationKeys = {
  homeAmenities: {
    titles: {
      hasHeatingBeenRenovated:
        'Le système de chauffage a-t-il été complètement remplacé dans les {{0}} dernières années?',
      hasDetachedStructure: "Y a-t-il des structures détachées autre qu'un cabanon ou un garage?",
      hasSepticTank: 'Y a-t-il une fosse septique?',
      hasSumpPump: 'Y a-t-il une pompe de puisard?',
    },
  },
};

export default keys;
